import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {makeStyles, Grid, Typography, Box, Divider} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import HotelSingleBed1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/hotels-spas/hotel-bedrooms/hotel-single-bed-1.svg";
import BathroomShower from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/hotels-spas/bathroom/bathroom-shower.svg";
import AppliancesSlowCooker from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/food-drinks/appliances/appliances-slow-cooker.svg";
import TableRestaurantBeach from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/furnitures-decoration/tables/table-restaurant-beach.svg";
import StairsPersonAscend from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/wayfinding/stairs/stairs-person-ascend.svg";
import DisabilityWheelchair1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/wayfinding/disability/disability-wheelchair-1.svg";
import {useI18N} from "../../../common/common";
import {StreamlineIcon} from "@hapinest/theme";


const useStyles = makeStyles((theme) => ({
    fontItalic: {
        fontStyle: "italic",
        fontWeight: "normal",
        fontSize: theme.spacing(1.75),
        lineHeight: "125%"
    },
    marginTop: {
        marginTop: -theme.spacing(1.875)
    },
    paddingBottom1: {
        paddingBottom: theme.spacing(1)
    },
    paddingRight: {
        paddingRight: theme.spacing(1.625),
        marginBottom: -theme.spacing(0.6)
    },
    colorSecondary: {
        color: theme.palette.secondary.main
    },
    colorGrey: {
        color: theme.palette.grey["900"]
    },
    paddingTopLeft: {
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(4.25)
    },
    title: {
        display: "inline-flex",
        width: "100%",
        alignItems: "center",
        marginBottom: theme.spacing(2)
    },
    streamlineIcon: {
        fontSize: theme.spacing(2.75),
        color: theme.palette.secondary["600"],
        marginRight: theme.spacing(1.625),
        verticalAlign: "bottom"
    }
}));

const ApartmentShowMoreContent = ({apartmentShowMore, apartmentExtraBed, apartmentWheelchair}) => {

    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <>
            {!apartmentShowMore && (
                <>
                    {[0, 1, 2, 3].map((i) => (
                        <React.Fragment
                            key={i}
                        >
                            <Grid
                                container
                                direction="row"
                                spacing={1}
                            >
                                <Grid
                                    item
                                    md={12}
                                    lg={12}
                                    xs={12}
                                    sm={12}
                                >
                                    <Typography
                                        variant={"overline"}
                                    >
                                        <Skeleton />
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                spacing={1}
                                className={classes.paddingTopLeft}
                            >
                                {[0, 1].map((j) => (
                                    <Grid
                                        item
                                        key={j}
                                        md={12}
                                        lg={12}
                                        xs={12}
                                        sm={12}
                                    >
                                        <Typography
                                            variant={"body2"}
                                        >
                                            <Skeleton />
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>

                            {i !== 3 &&
                                <Box
                                    py={2.5}
                                >
                                    <Divider />
                                </Box>
                            }
                        </React.Fragment>
                    ))}
                </>
            )}

            {apartmentShowMore?.apartmentCategorySleepingArrangementsCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <StreamlineIcon
                            className={classes.streamlineIcon}
                        >
                            <HotelSingleBed1 />
                        </StreamlineIcon>
                        <Typography
                            variant={"overline"}
                            className={classes.colorSecondary}
                        >
                            {i18n("dialog.apartments_show_more.sleeping")}
                        </Typography>
                    </Grid>
                </Grid>
            }

            <Grid
                container
                direction="row"
                spacing={1}
                className={classes.paddingTopLeft}
            >
                {apartmentShowMore?.apartmentCategorySleepingArrangementsCollection?.items.map((sleeping, index) => {
                    return (
                        <Grid
                            item
                            key={index}
                            md={12}
                            lg={12}
                            xs={12}
                            sm={12}
                        >
                            <Typography
                                variant={"body2"}
                                className={classes.colorGrey}
                            >
                                {sleeping?.title}
                            </Typography>
                        </Grid>
                    );
                })}

                {apartmentExtraBed &&
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <Typography>
                            {"+ "}
                            <span className={classes.fontItalic}>
                                {i18n("dialog.apartments_show_more.extra_bed")}
                            </span>
                        </Typography>
                    </Grid>
                }

                {apartmentShowMore?.spaceForABabybed &&
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <Typography>
                            {"+ "}
                            <span className={classes.fontItalic}>
                                {i18n("dialog.apartments_show_more.space_for_baby_bed")}
                            </span>
                        </Typography>
                    </Grid>
                }

            </Grid>

            {apartmentShowMore?.apartmentCategorySleepingArrangementsCollection?.items.length > 0 &&
                <Box
                    py={2.5}
                >
                    <Divider />
                </Box>
            }

            {apartmentShowMore?.apartmentCategoryBathroomCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <StreamlineIcon
                            className={classes.streamlineIcon}
                        >
                            <BathroomShower />
                        </StreamlineIcon>
                        <Typography
                            variant={"overline"}
                            className={classes.colorSecondary}
                        >
                            {i18n("dialog.apartments_show_more.bathing")}
                        </Typography>
                    </Grid>
                </Grid>
            }

            {apartmentShowMore?.apartmentCategoryBathroomCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                    className={classes.paddingTopLeft}
                >
                    {apartmentShowMore?.apartmentCategoryBathroomCollection?.items.map((bathroom, index) => {
                        return (
                            <Grid
                                item
                                key={index}
                                md={12}
                                lg={12}
                                xs={12}
                                sm={12}
                            >
                                <Typography
                                    variant={"body2"}
                                    className={classes.colorGrey}
                                >
                                    {bathroom?.title}
                                </Typography>
                            </Grid>
                        );
                    })}

                </Grid>
            }

            {apartmentShowMore?.apartmentCategoryBathroomCollection?.items.length > 0 &&
                <Box
                    py={2.5}
                >
                    <Divider />
                </Box>
            }

            {apartmentShowMore?.apartmentCategoryKitchenCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <StreamlineIcon
                            className={classes.streamlineIcon}
                        >
                            <AppliancesSlowCooker />
                        </StreamlineIcon>
                        <Typography
                            variant={"overline"}
                            className={classes.colorSecondary}
                        >
                            {i18n("dialog.apartments_show_more.cooking")}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <Box
                            pl={4}
                            pt={0.5}
                        >
                            <Typography
                                variant={"body2"}
                                className={classes.colorGrey}
                            >
                                {apartmentShowMore?.apartmentCategoryKitchenCollection?.items && apartmentShowMore?.apartmentCategoryKitchenCollection?.items.map(element => element.title).join(", ")}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            }

            {apartmentShowMore?.apartmentCategoryKitchenCollection?.items.length > 0 &&
                <Box
                    py={2.5}
                >
                    <Divider />
                </Box>
            }

            {apartmentShowMore?.apartmentCategoryOutdoorCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <StreamlineIcon
                            className={classes.streamlineIcon}
                        >
                            <TableRestaurantBeach />
                        </StreamlineIcon>
                        <Typography
                            variant={"overline"}
                            className={classes.colorSecondary}
                        >
                            {i18n("dialog.apartments_show_more.outside")}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <Box
                            pl={4}
                            pt={0.5}
                        >
                            <Typography
                                variant={"body2"}
                                className={classes.colorGrey}
                            >
                                {apartmentShowMore?.apartmentCategoryOutdoorCollection?.items && apartmentShowMore?.apartmentCategoryOutdoorCollection?.items.map(element => element.title).join(", ")}
                            </Typography>

                        </Box>
                    </Grid>
                </Grid>
            }

            {apartmentShowMore?.apartmentCategoryOutdoorCollection?.items.length > 0 &&
                <Box
                    py={2.5}
                >
                    <Divider />
                </Box>
            }

            {apartmentShowMore?.apartmentCategoryAccessibilityCollection?.items.length > 0 &&
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <StreamlineIcon className={classes.streamlineIcon}>
                            {apartmentWheelchair ? <DisabilityWheelchair1 /> : <StairsPersonAscend />}
                        </StreamlineIcon>
                        <Typography
                            variant={"overline"}
                            className={classes.colorSecondary}
                        >
                            {i18n("dialog.apartments_show_more.accessibility")}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        md={12}
                        lg={12}
                        xs={12}
                        sm={12}
                    >
                        <Box
                            pl={4}
                            pt={0.5}
                        >
                            {apartmentShowMore?.apartmentCategoryAccessibilityCollection?.items && apartmentShowMore?.apartmentCategoryAccessibilityCollection?.items.map((element, index) => {
                                return (
                                    <Typography
                                        key={index}
                                        variant={"body2"}
                                        className={clsx(classes.colorGrey, classes.paddingBottom1)}
                                    >
                                        {element.title}
                                    </Typography>
                                );
                            })}
                        </Box>
                    </Grid>
                </Grid>
            }
            {apartmentShowMore?.accessibilityHint &&
                <Grid
                    container
                    direction="row"
                >
                    <Grid
                        item
                    >
                        <Box
                            pl={4}
                            mt={1}
                            mb={1.25}
                        >
                            <Typography
                                variant={"body2"}
                                className={classes.colorGrey}
                            >
                                <i>{i18n("dialog.apartments_show_more.accessibility_hint")}</i>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            }
        </>
    );
};

ApartmentShowMoreContent.propTypes = {
    apartmentShowMore: PropTypes.object,
    apartmentExtraBed: PropTypes.bool,
    apartmentWheelchair: PropTypes.bool
};

export default ApartmentShowMoreContent;
